import React from 'react';
import { Link } from 'react-router-dom';
import instagramIcon from './../../assets/svg/instagram-icon.svg';
import facebookIcon from './../../assets/svg/facebook-icon.svg';
import arrowIcon from './../../assets/svg/arrow.svg';
import mapIcon from './../../assets/svg/map-icon.svg';
import phoneIcon from './../../assets/svg/phone-icon.svg';
import mailIcon from './../../assets/svg/mail-icon.svg';
import Logo2 from './../../assets/img/logo2.webp';

const Footer = () => {
  return (
    <footer className="bg-[#005478] py-10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-20">
            <div className="flex flex-col md:flex-row items-center justify-between mb-14 space-y-6 md:space-y-0">
                <div className="flex flex-row justify-center items-end space-x-4">
                    <img src={Logo2} alt="Logo" className="h-32" />
                    <h1 className="text-[#ffffff] text-xl font-customFont2">/ La baignade réinventée</h1>
                </div>
                <div className="flex flex-row justify-center items-center space-x-2">
                    <Link to="https://www.facebook.com/p/Isa-concept-d%C3%A9co-Stock-Tanks-Pool-100078317433676/" className="hover:scale-125 transition-all">
                        <img src={facebookIcon} alt="Facebook" className="h-8 w-8 bg-[#ffffff] rounded-full py-1 px-1" />
                    </Link>
                    <Link to="https://www.instagram.com/otankpool/" className="hover:scale-125 transition-all">
                        <img src={instagramIcon} alt="Instagram" className="h-8 w-8 bg-[#ffffff] rounded-full py-1 px-1" />
                    </Link>
                    <Link to="/#header" className="hover:scale-125 transition-all">
                        <img src={arrowIcon} alt="ArrowUp" className="h-8 w-8 bg-[#ffffff] rounded-full py-1 px-1" />
                    </Link>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-lg">
                <div className="flex flex-col items-center md:items-start">
                    <h2 className="font-bold text-[#ffffff] font-customFont1">Raccourcis</h2>
                    <ul className="grid grid-cols-1 gap-x-6 gap-y-2 mt-2 lg:grid-cols-2">
                        <li><Link to="/" className="text-[#d2d2d2] hover:text-[#ffffff] transition-all">Accueil</Link></li>
                        <li><Link to="/stocktanks" className="text-[#d2d2d2] hover:text-[#ffffff] transition-all">Stock Tanks</Link></li>
                        <li><Link to="/devis" className="text-[#d2d2d2] hover:text-[#ffffff] transition-all">Devis</Link></li>
                        <li><Link to="/faq" className="text-[#d2d2d2] hover:text-[#ffffff] transition-all">F.A.Q</Link></li>
                        <li><Link to="/guides" className="text-[#d2d2d2] hover:text-[#ffffff] transition-all">Guides</Link></li>
                    </ul>
                </div>
                <div className="flex flex-col items-center md:items-start">
                    <h2 className="font-bold text-[#ffffff] font-customFont1">Nous Contacter</h2>
                    <ul className="flex flex-col items-center mt-2 space-y-4 md:items-start">
                        <li className="flex items-center space-x-3">
                            <img src={mapIcon} alt="Map" className="h-5 w-5" />
                            <Link to="https://www.google.com/maps/dir/44.8393165,-0.5780456/6+Rue+du+Ch%C3%A2teau,+33580+Taillecavat/@44.6951409,-0.5456795,10z/data=!3m1!4b1!4m10!4m9!1m1!4e1!1m5!1m1!1s0x12aa99df8799f18d:0x58e9474bbfc6a1e0!2m2!1d0.1494273!2d44.6460185!3e0?entry=ttu&g_ep=EgoyMDI1MDExNS4wIKXMDSoASAFQAw%3D%3D" className="text-[#d2d2d2] hover:text-[#ffffff] transition-all">
                            6 Rue du château, le bourg, 33580 Taillecavat
                            </Link>
                        </li>
                        <li className="flex items-center space-x-3">
                            <img src={phoneIcon} alt="Icône téléphone" className="h-5 w-5" />
                            <a
                                href="tel:0671598537"
                                className="text-[#d2d2d2] hover:text-[#ffffff] transition-all"
                            >
                                +33 6 71 59 85 37
                            </a>
                        </li>

                        <li className="flex items-center space-x-3">
                            <img src={mailIcon} alt="Icône mail" className="h-5 w-5" />
                            <a
                                href="mailto:info@isaconceptdeco.fr"
                                className="text-[#d2d2d2] hover:text-[#ffffff] transition-all"
                            >
                                info@isaconceptdeco.fr
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col items-center md:items-start">
                    <h2 className="font-bold text-[#ffffff] font-customFont1">Restez informé</h2>
                    <div className="flex flex-col justify-center items-center md:items-start mt-2 space-y-2">
                        <input type="text" placeholder="Votre adresse e-mail" className="font-customFont2 bg-[#13455a] text-center w-72 px-8 py-4 my-3 text-white outline-none md:w-52 lg:w-80 2xl:w-[500px] md:text-start"/>
                        <button className="font-customFont1 bg-[#db7d2b] px-20 md:px-8 py-4 my-3 text-[#ffffff] hover:bg-[#b9671c] transition-all">S'abonner</button>
                    </div>
                </div>
            </div>
            <div className="flex flex-col md:flex-row justify-between items-center mt-16 text-center text-[#ffffff] space-y-4 md:space-y-0">
                <div>©2025 O Tank Pool - Tous droits réservés - <Link to="https://orazagency.fr">Création Baptiste Orazio</Link></div>
                <ul className="flex space-x-4">
                    <li><Link to="/mentions-legales" className="text-[#d2d2d2] hover:text-[#ffffff] transition-all">Mentions Légales</Link></li>
                    <li>-</li>
                    <li><Link to="/confidentialite" className="text-[#d2d2d2] hover:text-[#ffffff] transition-all">Confidentialité</Link></li>
                    <li>-</li>
                    <li><Link to="/cgu" className="text-[#d2d2d2] hover:text-[#ffffff] transition-all">CGU</Link></li>
                </ul>
            </div>
        </div>
    </footer>
  );
};

export default Footer;
